function normalizeBlocks(zen) {
  const raw = zen.blocks || zen.content?.blocks || zen.content;

  // Wenn bereits ein Array von Editor.js-Blöcken
  if (Array.isArray(raw)) {
    return raw.map((block) => {
      if (block?.type === "model") block.type = "model3d"; // Legacy-Kompatibilität
      return block;
    });
  }

  // Wenn content ein einfacher Textstring ist
  if (typeof raw === "string") {
    return [
      {
        type: "paragraph",
        data: {
          text: raw.replace(/\n/g, "<br>"), // \n → <br> für Zeilenumbrüche
        },
      },
    ];
  }

  return []; // Fallback
}

export async function loadZens() {
  const all = [];

  try {
    // 📥 1. Liste der Artikel-Dateien vom Server
    const res = await fetch("https://www.denisbitter.de/stage01/api/zens.php");
    const filenames = await res.json();

    // 🔁 2. Lade jede Datei einzeln
    for (const file of filenames) {
      try {
        const articleRes = await fetch(`https://www.denisbitter.de/stage01/api/zens.php?slug=${file}`);
       
        const json = await articleRes.json();

        all.push({
          ...json,
          blocks: normalizeBlocks(json),
          slug: slugify(json.title || "unbenannt"),
        });
      } catch (err) {
        console.warn(`⚠️ Artikel ${file} konnte nicht geladen werden:`, err);
      }
    }
  } catch (e) {
    console.error("❌ Fehler beim Laden der Zenliste:", e);
  }

  return all;
}

function slugify(title = "") {
  return title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
}
